import { EncryptStorage } from 'encrypt-storage'

const encryptStorage = new EncryptStorage(import.meta.env.VITE_SECRET_KEY, {
    prefix: '@elemis',
    stateManagementUse: true,
})

export default encryptStorage
